import { useDeleteETSTicketCommentMutation } from 'gcs-common/clients/api/entities/tickets/tickets-api';
import Button from '../../../../../Button/Button';
import PopUpModal from '../../../../../PopUpModal/PopUpModal';
import styles from './styles.module.scss';

interface TicketCommentDeleteModalProps {
  ticketId: string;
  commentId: string;
  onClose: VoidFunction;
}

const TicketCommentDeleteModal = (props: TicketCommentDeleteModalProps) => {
  const { ticketId, commentId, onClose } = props;
  const deleteETSTicketComment = useDeleteETSTicketCommentMutation();
  const deleting = deleteETSTicketComment.isPending;

  const handleDelete = async () => {
    try {
      await deleteETSTicketComment.mutateAsync({
        path: {
          ticket_id: ticketId,
          comment_id: commentId,
        },
      });
      onClose();
    } catch {
      // No need to do anything
    }
  };

  return (
    <PopUpModal
      className={styles.deleteModal}
      onRequestClose={onClose}
      isOpen
      title=""
      /** We need to be higher than the ticket dashboard drawer with z-index 10 */
      zIndex={20}
    >
      <div>
        <div className={styles.modalContent}>
          <p>Möchten Sie diesen Kommentar wirklich löschen?</p>
        </div>
        <div className={styles.buttonRow}>
          <Button className={styles.modalButtonCancel} type="button" onClick={onClose} disabled={deleting}>
            Nein
          </Button>
          <Button className={styles.modalButtonDelete} type="button" onClick={handleDelete} disabled={deleting}>
            Ja
          </Button>
        </div>
      </div>
    </PopUpModal>
  );
};

export default TicketCommentDeleteModal;
